import React from 'react'
import Products from './Product/Products'

const Home = () => {
  return (
    <div>
    <Products/></div>
  )
}

export default Home